import { Injectable } from '@angular/core';
import { filter, some } from 'lodash';
import { Observable } from 'rxjs/Observable';

import { ApiBase } from './base-api.service';
import {
  MarketBounds,
  MarketBoundsJSON,
  MarketDetail,
  MarketImageJSON,
  MarketLeaderboard,
  MarketProperties,
  MetricDescriptionsGroups,
  MetricDescriptionsGroupsJSON,
  RegionBoundary,
} from '~core/model';

@Injectable()
export class MarketService extends ApiBase {

  getMarketMetrics(): Observable<MarketDetail[]> {
    return this.get(`/markets/metrics`)
      .map(metrics => (metrics || [])
        .map(metric => new MarketDetail(metric)));
  }

  getMarketBounds(): Observable<MarketBounds[]> {
    return this.get(`assets/da-markets.json`, null, null, true, null, false)
      .combineLatest(this.getMarketMetrics())
      .map(([bounds, metrics]: [MarketBoundsJSON[], MarketDetail[]]) =>
        filter(bounds, b => some(metrics, m => b.id === m.id)).map(g => ({
          geometry: g.boundingBox,
          properties: {
            id: g.id,
            name: g.name,
            latitude: g.latitude,
            longitude: g.longitude,
            primaryState: g.primaryState,
            urlSlug: g.urlSlug
          }
        }))
      );
  }

  getMarketCenter(stateAbbr: string, marketName: string): Observable<MarketProperties> {
    return this.get(`assets/da-markets.json`, null, null, true, null, false)
      .map((bounds: MarketBoundsJSON[]) => {
        const marketDetail = bounds.find(bound => bound.urlSlug === marketName && bound.primaryState.toLowerCase() === stateAbbr);
        if (marketDetail) {
          return marketDetail;
        } else {
          throw new Error('Market not found!');
        }
      });
  }

  getMarketSlug(marketId: number): Observable<MarketBoundsJSON> {
    return this.get(`assets/da-markets.json`, null, null, true, null, false)
      .map((bounds: MarketBoundsJSON[]) => {
        const marketDetail = bounds.find(bound => bound.id === marketId);
        if (marketDetail) {
          return marketDetail;
        } else {
          throw new Error('Market not found!');
        }
      });
  }

  getMarketLeaderboard(marketId: number): Observable<MarketLeaderboard> {
    return this.get(`/markets/${marketId}/leaderboard`);
  }

  getMarketLeaderboardDescriptions(): Observable<MetricDescriptionsGroups[]> {
    return this.get('/markets/v2/leaderboardmetrics')
      .map((descriptions: MetricDescriptionsGroupsJSON) => descriptions.data);
  }

  getRegionsByMarket(marketId: number): Observable<RegionBoundary[]> {
    return this.get(`/geo/boundaries/market/${marketId}`)
      .map(regions => regions.map(r => new RegionBoundary(r[0])));
  }

  getMarketImage(): Observable<MarketImageJSON> {
    return this.get(`/markets/image/hero`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/market.service.ts